















































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import AWS from 'aws-sdk';
// @ts-ignore no d.ts
import { vTeleportLocation } from '@desislavsd/vue-teleport';
import LocalChanger from '../localchanger/localchanger.component.vue';
import { Action, State } from 'vuex-class';
import { User } from '@/models/user';
import { Project } from '@/models/project';
import { Storage, Auth } from 'aws-amplify';
import { Chrome } from 'vue-color';

@Component({
  components: {
    LocalChanger,
    vTeleportLocation,
    'color-picker': Chrome,
  },
})
export default class Navbar extends Vue {
  //@Prop({ type: Object, required: true }) private readonly project!: Project;
  @State('user', { namespace: 'profile' }) readonly user!: User;
  @State('authorized', { namespace: 'profile' }) readonly authorized!: boolean;
  @State('premium', { namespace: 'profile' }) readonly premium!: boolean;

  @Action('logout', { namespace: 'profile' }) logout!: () => Promise<void>;

  colors = [
    { id: 0, color: '#001326' },
    { id: 1, color: '#001a34' },
    { id: 2, color: '#002142' },
    { id: 3, color: '#001c38' },
    { id: 4, color: '#5078a0' },
    { id: 5, color: '#5fc9e4' },
    { id: 6, color: '#4dffcd' },
    // ...reste des couleurs
  ];
  showColorPicker = false;
  selectedColor = { hex: '' };
  selectedSquareId: number | null = null;
  private isDownloadingPDF = false;
  private logoUrl: string | null = null;

  private openColorPicker(color: string, id: number): void {
    console.log('Square clicked! Opening color picker...');
    if (this.selectedSquareId === id) {
      // Si le même carré est sélectionné, fermez le color picker
      this.showColorPicker = false;
      this.selectedSquareId = null;
    } else {
      this.showColorPicker = false;
      this.selectedColor = { hex: this.colors[id].color };
      this.selectedSquareId = id;
      this.$nextTick(() => {
        this.showColorPicker = true;
      });
    }
  }

  get isMobile(): boolean {
    return window.innerWidth <= 600; // Correspond à votre media query
  }

  get fullname(): string {
    if (this.user !== undefined) {
      return `${this.user.firstname} ${this.user.lastname ? this.user.lastname[0] : ''}.`;
    } else {
      return '';
    }
  }

  get currentLocaleName(): string {
    const map: Record<string, string> = {
      fr: 'Français',
      en: 'English',
      es: 'Español',
      it: 'Italiano',
      // ajoute tes locales supportées
    };
    return map[this.$i18n.locale] || this.$i18n.locale;
  }

  get maxData(): number {
    return this.premium ? 1024 : 100;
  }

  get userInitials(): string {
    const f = (this.user && this.user.firstname ? this.user.firstname[0] : '').toUpperCase();
    const l = (this.user && this.user.lastname ? this.user.lastname[0] : '').toUpperCase();
    return f + l || '…';
  }
  get userEmail(): string {
    return this.user && this.user.email ? this.user.email : '';
  }

  signOut(): Promise<void> {
    return this.logout();
  }

  async mounted() {
    const savedColors = localStorage.getItem('colors');
    if (savedColors) {
      this.colors = JSON.parse(savedColors);
    }
  }

  closeDropdown(): void {
    const dropdown = this.$refs.userDropdown as any; // cast pour bypass TS
    if (dropdown && typeof dropdown.hide === 'function') {
      dropdown.hide(true);
    }
  }

  public requestFullscreen(): void {
    let el: any = document.documentElement;

    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el['mozRequestFullScreen']) {
      // Firefox
      el['mozRequestFullScreen']();
    } else if (el['webkitRequestFullscreen']) {
      // Chrome, Safari and Opera
      el['webkitRequestFullscreen']();
    } else if (el['msRequestFullscreen']) {
      // IE/Edge
      el['msRequestFullscreen']();
    }
  }

  public exitFullscreen(): void {
    let doc: any = document;

    if (doc.exitFullscreen) {
      doc.exitFullscreen();
    } else if (doc['mozCancelFullScreen']) {
      // Firefox
      doc['mozCancelFullScreen']();
    } else if (doc['webkitExitFullscreen']) {
      // Chrome, Safari and Opera
      doc['webkitExitFullscreen']();
    } else if (doc['msExitFullscreen']) {
      // IE/Edge
      doc['msExitFullscreen']();
    }
  }

  public toggleFullscreen(): void {
    let doc: any = document;

    if (
      !doc.fullscreenElement &&
      !doc['mozFullScreenElement'] &&
      !doc['webkitFullscreenElement'] &&
      !doc['msFullscreenElement']
    ) {
      // Aucun élément en mode plein écran : passage en mode plein écran
      this.requestFullscreen();
    } else {
      // Un élément est déjà en plein écran : on quitte le mode plein écran
      this.exitFullscreen();
    }
  }

  private async downloadPDF() {
    this.isDownloadingPDF = true;
    try {
      // Remplacez 'guide.pdf' par la clé de votre PDF dans le bucket S3
      const pdfKey = 'guide.pdf';
      const pdfUrl = await Storage.get(pdfKey, { level: 'public' });

      // Ouvrez le PDF dans un nouvel onglet
      window.open(pdfUrl as string, '_blank');
    } catch (error) {
      console.error('Erreur lors du téléchargement du PDF:', error);
      this.$bvToast.toast('Erreur lors du téléchargement du PDF.', {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
    } finally {
      this.isDownloadingPDF = false;
    }
  }

  public openUserGuide() {
    window.open('https://bit.ly/TEYE-Userguide', '_blank');
  }

  @Watch('selectedColor')
  private onSelectedColorChange(newColor: { hex: string }) {
    if (this.selectedSquareId !== null) {
      this.colors[this.selectedSquareId].color = newColor.hex;
      // Modifier la variable CSS correspondante
      switch (this.selectedSquareId) {
        case 0:
          document.documentElement.style.setProperty('--bleu-fonce', newColor.hex);
          break;
        case 1:
          document.documentElement.style.setProperty('--bleu-gradient-mid', newColor.hex);
          break;
        case 2:
          document.documentElement.style.setProperty('--bleu-gradient-end', newColor.hex);
          break;
        case 3:
          document.documentElement.style.setProperty('--bleu-clair', newColor.hex);
          break;
        case 4:
          document.documentElement.style.setProperty('--bleu-normal', newColor.hex);
          break;
        case 5:
          document.documentElement.style.setProperty('--bleu-light', newColor.hex);
          break;
        case 6:
          document.documentElement.style.setProperty('--vert', newColor.hex);
          break;
      }
    }
  }

  @Watch('colors')
  private saveColorsToLocalStorage() {
    localStorage.setItem('colors', JSON.stringify(this.colors));
  }

  // Méthode pour mettre la première lettre en majuscule
  capitalize(text: string): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
